import React, {PureComponent} from 'react';
import {Spin} from 'antd';
import {withTranslation, WithTranslation} from 'react-i18next'
import {Bar, defaults, Line} from "react-chartjs-2";
import {TimesheetSummary} from '../stores/timesheets-store';
import {EmployeesReport} from '../stores/employee-report-store';

defaults.global.defaultFontFamily = "'Avenir','Helvetica Neue','Arial','Helvetica',sans-serif"
defaults.global.defaultFontSize = 14

export interface TimesheetTaskEntryItem {
    day: number,
    planned: number,
    hours: number
}

export interface TimesheetTaskItem {
    projectTaskId: string,
    title: string,
    taskTitle: string,
    projectTitle: string,
    entries: TimesheetTaskEntryItem[]
}

export interface TimesheetItem extends TimesheetSummary {
    tasks: TimesheetTaskItem[]
}

export interface EmployeeReport {
    employeeId: string,
    employeeName: string,
    projectTaskIds: string[],
    projectIds: string[],
    projectIdPerTask: Map<string,string>,
    projectNames: Map<string, string>,
    workedHoursPerTask: Map<string, number>,
    workedHoursPerProject: Map<string, number>,
    totalWorkedHours: number
}

interface EmployeesReportChartProps extends WithTranslation {
    data: EmployeesReport,
    projectId: string,
    colors: string[],
    renderToggle: boolean,
    showBar?: boolean,
    showPie?: boolean
}

interface EmployeesReportChartState {
    renderToggle: boolean,
    isBusy: boolean,
}

export function GetEmployeeReportFromTimesheet(timesheet: TimesheetItem, into: EmployeeReport): EmployeeReport{
    
    timesheet.tasks.forEach(value => {
        let workedHours = value.entries.sum(x => x.hours)
        if (workedHours === 0) //don't stash task if no hours where imputed
            return;

        //add task if new
        if (!into.workedHoursPerTask.has(value.projectTaskId)) 
            into.projectTaskIds.push(value.projectTaskId)

        //sum all registered hours into total and task worked hours
        let registeredHours = into.workedHoursPerTask.get(value.projectTaskId) ?? 0
        into.workedHoursPerTask.set(value.projectTaskId, registeredHours + workedHours)
        into.totalWorkedHours += workedHours
    })
    return into
}

class ProjectReportChart extends PureComponent<EmployeesReportChartProps, EmployeesReportChartState> {

    constructor(props: EmployeesReportChartProps) {
        super(props);

        this.state = {
            renderToggle: this.props.renderToggle,
            isBusy: false
        }
    }
    private parseTime(h: any, format?: any) {
        if (format == null) {
            var hours = parseFloat(h).toFixed(2)
            return hours
        }
    }

    render() {
        var self = this
        const { t } = this.props;
        const showBar = this.props.showBar
        const showPie = this.props.showPie
        const colors = this.props.colors

        //build labels legend
        var projectTaskIds: string[] = []
        var projectTaskNames: string[] = []
        Array.from(this.props.data.projectTaskIdToName).forEach((item) => {
            projectTaskIds.push(item[0])
            projectTaskNames.push(item[1])
        })

        let data = {
            labels: projectTaskNames,
            datasets: this.props.data.reports.map((report, index) => {
                return {
                    label: report.employeeName,
                    data: projectTaskIds.map(id => (this.parseTime(report.workedHoursPerTask.get(id))) ?? 0),
                    fill: true,
                    backgroundColor: colors[index],
                    hoverBackgroundColor: colors[index],
                    borderColor: 'rgba(200, 200, 200, 0.75)',
                    hoverBorderColor: 'rgba(200, 200, 200, 1)'
                }
            })
        }

        let options = {
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true
                    }
                }],
                xAxes: [{
                    barPercentage: 0.4
                }]
            },
            responsive: true,
            maintainAspectRatio: false,
            title: {
                display: true,
                text: t("Worked hours per task")
            }
        }

        const monthNames = [t("January"), t("February"), t("March"), t("April"), t("May"), t("June"),
        t("July"), t("August"), t("September"), t("October"), t("November"), t("December")];

        const lineDataTime = {
            datasets: this.props.data.reports.map((r, index) => ({
                data: r.totalWorkedHoursByMonth,
                borderColor: colors[index],
                label: r.employeeName,
                fill: false,
                tension: 0
            })),
            labels: monthNames
        }

        const lineOptionsTime = {
            responsive: true,
            maintainAspectRatio: false,
            title: {
                display: true,
                text: t("Total worked hours by month")
            }
        };

        return <Spin size='large' spinning={this.state.isBusy} style={{ width: "100%" }}>
            <div className="flex-container" style={{ padding: 10, width: "100%", height: "60vh" }}>
                {showBar &&
                    < div className="flex" style={{ width: "50%" }}>
                            <Bar
                            data={data}
                            options={options}
                        redraw={true}
                        />
                    </div>}
                {showPie &&
                    < div className="flex" style={{ width: "50%" }}>
                        <Line data={lineDataTime} options={lineOptionsTime} />
                    </div>}
            </div>
        </Spin>
    }
}
export default withTranslation()(ProjectReportChart);
